<template>
  <section class="contact-form-section">
    <div class="contact-form-title">{{ t('contactUs.contactForm.title') }}</div>
    <form class="contact-form-wrap">
      <div class="contact-form-row">
        <input class="contact-form-input" type="text" :placeholder="t('contactUs.contactForm.emailPlaceholder')" />
        <input class="contact-form-input" type="text" :placeholder="t('contactUs.contactForm.subjectPlaceholder')" />
      </div>
      <textarea class="contact-form-textarea" rows="4"
        :placeholder="t('contactUs.contactForm.messagePlaceholder')"></textarea>
      <div class="contact-form-btn-row">
        <button class="contact-form-btn" disabled type="submit">{{ t('contactUs.contactForm.submitButton') }}</button>
      </div>
    </form>
  </section>
</template>
<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>
<style scoped>
.contact-form-section {
  width: 100%;
  background: #fff;
  padding: 48px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 100px
}

.contact-form-title {
  text-align: center;
  /* 需要适配 */
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 24px;
}

.contact-form-wrap {
  width: 65%;
  padding: 24px 24px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.contact-form-input {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  /* 需要适配 */
  font-size: 1rem;
  outline: none;
}

.contact-form-textarea {
  width: 98%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  /* 需要适配 */
  font-size: 1rem;
  resize: vertical;
  outline: none;
  min-height: 180px;
}

.contact-form-btn-row {
  display: flex;
  justify-content: flex-end;
}

.contact-form-btn {
  background: #ff7f1a;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 10px 32px;
  /* 需要适配 */
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}

.contact-form-btn:hover {
  background: #ff6600;
}

.contact-form-btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .contact-form-wrap {
    width: 65%;
  }

  .contact-form-title {
    font-size: 2rem;
  }

  .contact-form-input {
    font-size: 1.2rem;
  }

  .contact-form-textarea {
    font-size: 1.1rem;
  }

  .contact-form-btn {
    font-size: 1.2rem;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .contact-form-wrap {
    width: 75%;
  }
  .contact-form-title {
    font-size: 1.8rem;
  }

  .contact-form-input {
    font-size: 1.1rem;
  }

  .contact-form-textarea {
    font-size: 1rem;
  }

  .contact-form-btn {
    font-size: 1.1rem;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .contact-form-wrap {
    width: 85%;
  }
  .contact-form-title {
    font-size: 1.6rem;
  }

  .contact-form-input {
    font-size: 1rem;
  }

  .contact-form-textarea {
    font-size: 0.9rem;
  }

  .contact-form-btn {
    font-size: 1rem;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .contact-form-title {
    font-size: 1.4rem;
  }

  .contact-form-input {
    font-size: 0.9rem;
  }

  .contact-form-textarea {
    font-size: 0.8rem;
  }

  .contact-form-btn {
    font-size: 0.9rem;
  }
}
</style>